function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box } from "../Box";
import { BunnySlider, BarBackground, BarProgress, BunnyButt, StyledInput, SliderLabel, SliderLabelContainer } from "./styles";
var Slider = function(_param) {
    var name = _param.name, min = _param.min, max = _param.max, value = _param.value, onValueChanged = _param.onValueChanged, valueLabel = _param.valueLabel, _step = _param.step, step = _step === void 0 ? "any" : _step, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, props = _objectWithoutProperties(_param, [
        "name",
        "min",
        "max",
        "value",
        "onValueChanged",
        "valueLabel",
        "step",
        "disabled"
    ]);
    var handleChange = function(param) {
        var target = param.target;
        onValueChanged(parseFloat(target.value));
    };
    var progressPercentage = value / max * 100;
    var isMax = value === max;
    var progressWidth;
    if (progressPercentage <= 10) {
        progressWidth = "".concat(progressPercentage + 0.5, "%");
    } else if (progressPercentage >= 90) {
        progressWidth = "".concat(progressPercentage - 4, "%");
    } else if (progressPercentage >= 60) {
        progressWidth = "".concat(progressPercentage - 2.5, "%");
    } else {
        progressWidth = "".concat(progressPercentage, "%");
    }
    var labelProgress = isMax ? "calc(100% - 12px)" : "".concat(progressPercentage, "%");
    var displayValueLabel = isMax ? "MAX" : valueLabel;
    return /*#__PURE__*/ _jsxs(Box, _objectSpread({
        position: "relative",
        height: "48px"
    }, props, {
        children: [
            /*#__PURE__*/ _jsx(BunnyButt, {
                disabled: disabled
            }),
            /*#__PURE__*/ _jsxs(BunnySlider, {
                children: [
                    /*#__PURE__*/ _jsx(BarBackground, {
                        disabled: disabled
                    }),
                    /*#__PURE__*/ _jsx(BarProgress, {
                        style: {
                            width: progressWidth
                        },
                        disabled: disabled
                    }),
                    /*#__PURE__*/ _jsx(StyledInput, {
                        name: name,
                        type: "range",
                        min: min,
                        max: max,
                        value: value,
                        step: step,
                        onChange: handleChange,
                        isMax: isMax,
                        disabled: disabled
                    })
                ]
            }),
            valueLabel && /*#__PURE__*/ _jsx(SliderLabelContainer, {
                children: /*#__PURE__*/ _jsx(SliderLabel, {
                    progress: labelProgress,
                    children: displayValueLabel
                })
            })
        ]
    }));
};
export default Slider;
